import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./UserSummaryStatsContainer.module.scss";

export interface IUserSummaryStatsContainerProps {
  label: string;
  value: number | string;
  maxValue?: number | string;
}

export const UserSummaryStatsContainer: VoidFunctionComponent<IUserSummaryStatsContainerProps> = ({label, value, maxValue}) => {
  return (
    <div className={s.container}>
      <dt className={s.value}>
        {value}
        {maxValue ? (
          <>
            <span> / </span>
            <span className={`level-points-possible`}>{maxValue}</span>
          </>
        ): null}
      </dt>
      <dd className={s.label}>{label}</dd>
      {maxValue ? <progress className={s.progress} max={maxValue} value={value}></progress> : null}
    </div>
  );
}
